import { useContext } from 'react';
import { ConsentContext } from './consentContext';

/**
 * État de consentement pour un composant qui s'apprête à charger du tiers.
 *
 * N'importe **que** le contexte, jamais la bibliothèque de consentement : les
 * blocs sont partagés avec l'éditeur, qui n'a aucune raison d'embarquer le code
 * de la bannière.
 */
export function useConsent() {
  return useContext(ConsentContext);
}
